import { Modal } from '@perch-labs/shrike';
import styled from 'styled-components';

export const ReviewDialogHeader = styled(Modal.Header)`
  padding: 13px, 8px, 13px, 8px;
`;

export const PdfDialog = styled.div`
  max-height: 400px;
  overflow: auto;
`;
